@import (reference) '../../../../constants/spacing.module.less';

.rate-shopper-audit {
  font-size: 12px;
  border: 1px solid var(--grey-300);
  border-radius: 4px;
  background-color: var(--rate-shopper-audit-background-color);
}

.rate-shopped-service,
.row-header {
  display: grid;
  grid-template-columns: 1fr 200px 60px;
  padding: @space-4 @space-12;
  &.highlighted {
    font-weight: 500;
    background-color: var(--grey-300);
  }
}

.rate-shopped-service:last-child {
  padding-bottom: @space-12;
}

.row-header {
  border-bottom: 1px solid var(--grey-300);
  margin-bottom: @space-8;
}

.audit-header {
  justify-content: space-between;
  padding: @space-12;
  cursor: pointer;
}

.bold {
  font-weight: 500;
}

.expand-icon {
  height: 12px;
  width: 12px;
}

.rate-shopper-link {
  display: flex;
  gap: @space-4;
}

.rate-shopper-label {
  font-weight: 500;
}

.align-right {
  text-align: right;
}

.show-hide-link {
  cursor: pointer;
  display: flex;
  justify-content: flex-end;
  padding: @space-4 @space-12 @space-8;
  button {
    font-size: 12px;
  }
}

.rate-error {
  color: var(--red-800);
}

.scrollable-section {
  max-height: 150px;
  overflow-y: auto;
}
